import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";


export function useParentRollNumbers(FromDate, ToDate) {
  const [parentRollNumbers, setParentRollNumbers] = useState([]);
  const [parentRollLoading, setParentRollLoading] = useState(false);
  const [parentRollError, setParentRollError] = useState(null);

  useEffect(() => {
    if (!FromDate || !ToDate) return;

    const fetchParentRolls = async () => {
      setParentRollLoading(true);
      setParentRollError(null);

      try {
        const p_companyid = localStorage.getItem("companyid");
        const p_frommodate = dayjs(FromDate).format("YYYY-MM-DD HH:mm:ss");
        const p_tomodate = dayjs(ToDate).format("YYYY-MM-DD HH:mm:ss");

        const orderData = {
          p_companyid,
          p_frommodate,
          p_tomodate,
          p_filtertype: "",
          p_mono: 0,
        };

        const data = await callApi(
          API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_LIST,
          "POST",
          { "Content-Type": "application/json" },
          orderData
        );

        setParentRollNumbers(Array.isArray(data) ? data : []);
        if (!data?.length) {
          console.warn("No parent roll data available for the given range.");
        }
      } catch (err) {
        console.error("Error fetching parent roll list:", err.message);
        setParentRollError(err);
      } finally {
        setParentRollLoading(false);
      }
    };

    fetchParentRolls();
  }, [FromDate, ToDate]);

  return { parentRollNumbers, parentRollLoading, parentRollError };
}
